import { createFileRoute } from '@tanstack/react-router';
import { TaskPlanPage } from '@/features/tasks/plan/TaskPlanPage';

export const Route = createFileRoute('/_app/tasks/plan')({ component: TaskPlanPage });
